export default function MailList() {
  return (
    <>
      <p>Manage the mailing lists here</p>
    </>
  );
}
